import React from 'react';
import { Label, Select } from '@/shared/components';
import { FOUR_BY_FOUR_OPTIONS, NON_4X4_HINT, type FourByFourChoice } from '../utils/fourByFourChoice';

interface Props {
    value: FourByFourChoice | undefined;
    onChange: (value: string) => void;
    onBlur?: () => void;
    disabled: boolean;
}

export const PlanVehicleRuleFourByFourField: React.FC<Props> = ({ value, onChange, onBlur, disabled }) => (
    <div className="flex flex-col">
        <Label id="pvr_requires_4x4-label">
            4x4 <span className="text-mp-muted">(optional)</span>
        </Label>
        <Select
            id="pvr_requires_4x4"
            options={FOUR_BY_FOUR_OPTIONS}
            value={value ?? ''}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            ariaLabelledBy="pvr_requires_4x4-label"
            hint={value === 'non_4x4' ? NON_4X4_HINT : undefined}
        />
    </div>
);
